import { render, staticRenderFns } from "./DocumentInsertionRequest.vue?vue&type=template&id=886b74c4&"
import script from "./DocumentInsertionRequest.vue?vue&type=script&lang=ts&"
export * from "./DocumentInsertionRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports